var jsts = require("jsts");

var Geometry = require("./basicGeometry.js");

Geometry.buffer = function(polys,dist) {
    var factory = new jsts.geom.GeometryFactory();

    var buffered = [];

    for (var i = 0; i < polys.length; i++) {
        var poly = polys[i];

        var geomPoly = new Geometry.Polygon();
        geomPoly.fromJsts(poly);

        var shell = geomPoly.fastBuffer(dist).toJstsRing();

        var holes = [];
        for(var j=0;j < poly.getNumInteriorRing(); j++) {
            var temp = new Geometry.Polygon();
            temp.fromJstsLinRing(poly.getInteriorRingN(j));
            var hole = temp.fastBuffer(dist).toJstsRing();
            holes.push(hole);
        }

        var jstsPoly = factory.createPolygon(shell,holes);
        buffered.push(jstsPoly);
    }

    return buffered;
};

module.exports = Geometry.buffer;

